__turbopack_context__.v({
  "enterDrawCountdown": "EnterDrawCountdown-module__Jpejna__enterDrawCountdown",
});
